module.exports = __webpack_public_path__ + "assets/img/download-btn-back.d7ac01a3.png";